import {
  ArrowLeftOutlined,
  CalendarOutlined,
  EditOutlined,
  MessageFilled,
  MessageOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { useTranslate } from '@tolgee/react';
import { Button, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useGlobalActions } from '../../../global-context/GlobalContext';
import useIsMobile from '../../../hooks/utils/useIsMobile';
import { useTastingService } from '../../../hooks/utils/useTastingService';
import {
  daysOfWeek,
  getDateTimeString,
  getDateYearString,
  ISelectedDays,
} from '../../../utils/calendarUtility';
import { showToast } from '../../../utils/commonUtility';
import Loader from '../../common/loader/Loader';
import { SidebarSlider } from '../../common/sidebar-slider/SidebarSlider';
import {
  TastingStatuses,
  tastingStutusesData,
} from '../requests-calendar-outline/RequestsCalendarOutline';
import './RequestsRemarks.scss';

const { Text } = Typography;
export const RequestsRemarks = ({
  refetchMainCalendarData,
}: {
  refetchMainCalendarData: () => any;
}) => {
  const {
    getBookingsByPage,
    tastingDataByPage,
    cancelTasting,
    updateStaffingReservation,
    cancelBookingLoading,
    hasMoreData,
    updateReservationLoading,
  } = useTastingService();

  const [openCommentDayCard, setOpenCommentDayCard] = useState<null | number>(
    null,
  );
  const { t } = useTranslate();
  const isMobile = useIsMobile();
  const [page, setPage] = useState<number>(1);

  const [availableData, setAvailableData] = useState<any>([]);
  const fetchMoreData = () => {
    setPage(prev => prev + 1);
  };
  useEffect(() => {
    getBookingsByPage(page);
  }, [page]);
  useEffect(() => {
    if (!tastingDataByPage) return;
    setAvailableData((prev: any) => [...prev, ...tastingDataByPage]);
  }, [tastingDataByPage]);
  console.log(
    'availableData===>',
    availableData,
    'RequestsRemarks.tsx line 62',
  );
  const { setOpenedRemarksPanelType } = useGlobalActions();

  return (
    <SidebarSlider
      width={isMobile ? '100%' : '25%'}
      visible={true}
      styles={{ backgroundColor: '#fcfafb' }}
      setVisibility={() => {
        setOpenedRemarksPanelType('NONE');
      }}
    >
      <div style={{ margin: '2rem 0', background: '#fbf7f7' }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            margin: '0 1rem',
          }}
        >
          <Text
            style={{
              fontSize: '1.6rem',
              color: '#275747',
            }}
          >
            {t('remarks')}
          </Text>
          <ArrowLeftOutlined
            onClick={() => setOpenedRemarksPanelType('NONE')}
            color='#275747'
            style={{ fontWeight: '900', fontSize: '18px', cursor: 'pointer' }}
          />
        </div>
        <InfiniteScroll
          dataLength={availableData.length}
          next={fetchMoreData}
          hasMore={hasMoreData}
          scrollableTarget='sidebar-slider'
          loader={
            <div
              style={{ position: 'relative', width: '100%', height: '10rem' }}
            >
              <Loader />
            </div>
          }
        >
          {availableData.map((data: ISelectedDays, index: number) => (
            <DayCard
              key={data.id}
              data={data}
              setCommentOpen={id => {
                setOpenCommentDayCard(id == openCommentDayCard ? null : id);
              }}
              showComments={openCommentDayCard == data.id}
              ctaLoading={
                cancelBookingLoading ||
                updateReservationLoading ||
                data.status == TastingStatuses.CANCELED
              }
              deleteData={(id: number) => {
                cancelTasting(id, (data: any) => {
                  refetchMainCalendarData();
                  showToast('event-deleted', 'success');
                  setOpenedRemarksPanelType('NONE');
                });
              }}
              updateData={(id: number, reason: string) => {
                updateStaffingReservation(id, reason, (data: any) => {
                  showToast('event-updated', 'success');
                  setOpenedRemarksPanelType('NONE');
                });
              }}
            />
          ))}
        </InfiniteScroll>
      </div>
    </SidebarSlider>
  );
};

const DayCard: React.FC<{
  data: ISelectedDays;
  deleteData: (statusId: number, onCompleteCb?: (data: any) => any) => void;
  showComments: boolean;
  setCommentOpen: (id: number) => any;
  updateData: (
    statusid: number,
    reason: string,
    onCompleteCb?: (data: any) => any,
  ) => void;
  ctaLoading: boolean;
}> = ({
  data,
  deleteData,
  updateData,
  ctaLoading,
  setCommentOpen,
  showComments,
}) => {
  const [comments, setComments] = useState(data.comments);
  const { t } = useTranslate();
  console.log('data.status===>', data.status, 'RequestsRemarks.tsx line 164');
  const toggleComments = () => {
    setCommentOpen(data.id);
  };

  const handleSubmit = () => {
    updateData(data.id, comments, data => {
      if (data?.updateCompanyStaffingStatus?.data?.isUpdate) {
        showToast('event-updated', 'success', 'event-updated-desc');
      }
    });
  };

  const handleDelete = () => {
    deleteData(data.id);
  };

  return (
    <div
      className='request-card'
      style={{ backgroundColor: !showComments ? '#fbf7f7' : '#ffff' }}
    >
      <div className='request-header'>
        <div className='icon-container' style={{ background: data.color }}>
          <data.Icon className='icon' />
        </div>
        <div className='request-details'>
          <strong className='status'>
            {t(tastingStutusesData[data.status].text)}
          </strong>
          <div className='date-info'>
            <CalendarOutlined /> {t(daysOfWeek[data.startdate.getDay()])}{' '}
            {getDateYearString(data.startdate.toISOString(), t)}
          </div>
          <div className='time-info'>
            <EditOutlined /> {t('updated')}{' '}
            {getDateTimeString(data.modifiedAt, t)}
          </div>
          <div className='people-info'>
            <UserOutlined /> {t('number-people')} {data?.maxCapacity}
          </div>
        </div>
      </div>
      <div className='comments-toggle' onClick={toggleComments}>
        <span className='comments-text'>{t('comments')}</span>
        {data?.comments.length ? <MessageFilled /> : <MessageOutlined />}
      </div>
      {showComments && (
        <div className='comments-section'>
          <textarea
            value={comments}
            disabled={data.status == TastingStatuses.CANCELED}
            onChange={e => setComments(e.target.value)}
            className='comments-input'
          />

          <div className='button-space'>
            <Button className='delete-button' onClick={toggleComments}>
              {t('cancel')}
            </Button>
            <Button
              className='submit-button'
              disabled={ctaLoading || data.comments == comments}
              onClick={handleSubmit}
            >
              {t('submit')}
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};
